import LangEnum from '../../../lang/LangEnum';
import { TargetStatus } from '../../../services/modules/target/target.types';

export enum TargetValueDetail {
  PLANNED = 'PLANNED',
  PLANNED_AND_ATTAINED = 'PLANNED_AND_ATTAINED',
}

export const TARGET_VALUE_DETAIL_BY_STATUS: Record<TargetStatus, TargetValueDetail | null> = {
  [TargetStatus.SUGGESTED]: null,
  [TargetStatus.DRAFT]: null,
  [TargetStatus.OPEN]: TargetValueDetail.PLANNED,
  [TargetStatus.CLOSED]: TargetValueDetail.PLANNED_AND_ATTAINED,
  [TargetStatus.CLOSED_WON]: TargetValueDetail.PLANNED_AND_ATTAINED,
  [TargetStatus.CLOSED_LOST]: TargetValueDetail.PLANNED_AND_ATTAINED,
  [TargetStatus.CANCELED]: null,
};

export const isTargetStatus = (status: string): status is TargetStatus =>
  Object.values<string>(TargetStatus).includes(status);

export const TARGET_LOSS_REASON_LABEL: Partial<Record<string, LangEnum>> = {
  UNATTRACTIVE_COLLECTION: LangEnum.TARGET_LOSS_REASON_UNATTRACTIVE_COLLECTION,
  UNATTRACTIVE_BUSINESS_POLICY: LangEnum.TARGET_LOSS_REASON_UNATTRACTIVE_BUSINESS_POLICY,
  UNATTRACTIVE_PRICE: LangEnum.TARGET_LOSS_REASON_UNATTRACTIVE_PRICE,
  HIGH_STOCK: LangEnum.TARGET_LOSS_REASON_HIGH_STOCK,
  BLOCKED_CUSTOMER: LangEnum.TARGET_LOSS_REASON_BLOCKED_CUSTOMER,
  BILLING_ISSUES: LangEnum.TARGET_LOSS_REASON_BILLING_ISSUES,
  REPLACEMENT_BY_FRANCHISE_OR_STORE: LangEnum.TARGET_LOSS_REASON_REPLACEMENT_BY_FRANCHISE_OR_STORE,
  REPLACEMENT_BY_ANOTHER_RETAILER: LangEnum.TARGET_LOSS_REASON_REPLACEMENT_BY_ANOTHER_RETAILER,
  WEBSITE_CONFLICT: LangEnum.TARGET_LOSS_REASON_WEBSITE_CONFLICT,
  WILL_BUY_NEXT_COLLECTION: LangEnum.TARGET_LOSS_REASON_WILL_BUY_NEXT_COLLECTION,
  CUSTOMER_FROM_ANOTHER_BRAND_OF_GROUP:
    LangEnum.TARGET_LOSS_REASON_CUSTOMER_FROM_ANOTHER_BRAND_OF_GROUP,
  CNPJ_CHANGE: LangEnum.TARGET_LOSS_REASON_CNPJ_CHANGE,
  STORE_CLOSED: LangEnum.TARGET_LOSS_REASON_STORE_CLOSED,
  NATURAL_DISASTERS: LangEnum.TARGET_LOSS_REASON_NATURAL_DISASTERS,
};
